export enum ArticleType {
  EXHIBITION,
  WORKSHOP,
  EVENT,
  EDUCATION,
  PARTNERSHIP,
  PUBLIC_ENGAGEMENT,
  PROJECT_DEVELOPMENT,
  LECTURE,
  PROFESSIONAL_DEVELOPMENT,
  FIELDTRIP,
}

export type ArticleImage = {
  id: string,
  url: string,
  articleId: string,
}

export const ArticleTypeLabels: Record<string, string> = {
  EXHIBITION: "Exhibition",
  WORKSHOP: "Workshop",
  EVENT: "Event",
  EDUCATION: "Education",
  PARTNERSHIP: "Partnership",
  PUBLIC_ENGAGEMENT: "Public Engagement",
  PROJECT_DEVELOPMENT: "Project Development",
  LECTURE: "Lecture",
  PROFESSIONAL_DEVELOPMENT: "Professional Development",
  FIELDTRIP: "Fieldtrip",
}

export type ArticleTag = {
  id: string,
  /** Prisma / API return string enum values (e.g. "LECTURE"). */
  type: keyof typeof ArticleTypeLabels | ArticleType,
  articleId: string,
}

/** Types that belong on the Education → Lectures page (not Events). */
export const LECTURE_PAGE_TYPES = [
  "LECTURE",
  "PROFESSIONAL_DEVELOPMENT",
  "FIELDTRIP",
] as const;

const LECTURE_RELATED_TYPES = new Set<string>(LECTURE_PAGE_TYPES);

/** Category chips shown on the Events page (excludes lecture-page tags). */
export const EventTypeLabels: Record<string, string> = Object.fromEntries(
  Object.entries(ArticleTypeLabels).filter(([key]) => !LECTURE_RELATED_TYPES.has(key)),
)

export type Article = {
  id: string | number;
  createdAt: string;
  types: ArticleTag[];
  title: string;
  description: string;
  images: ArticleImage[];
  text: string;
  sourceTitle: string;
  sourceUrl: string;
};
